/**
 * @desc Reducers Action List
 */
export const SET_CURRENT_USER = 'SET_CURRENT_USER';

// User
export const GET_USERS_LIST = 'GET_USERS_LIST';
export const CLEAR_USER_REDUCER = 'CLEAR_USER_REDUCER';
export const SET_SELECTED_USER_ID = 'SET_SELECTED_USER_ID';

// Messages
export const SEND_MESSAGE = 'SEND_MESSAGE';
export const SET_DATA_MISTAKES_MODAL_MESSAGE = 'SET_DATA_MISTAKES_MODAL_MESSAGE';

// Socket
export const SOCKET_CONNECT = 'SOCKET_CONNECT';
export const SOCKET_DISCONNECT = 'SOCKET_DISCONNECT';
export const SOCKET_SET_USERS = 'SOCKET_SET_USERS';
export const SOCKET_ADD_USER = 'SOCKET_ADD_USER';

// Macro
export const SET_MACRO_MODAL_STATUS = 'SET_MACRO_MODAL_STATUS';
